export const SN_LANGUAGE = 'languages'
export const CHANGES_LANGUAGE = SN_LANGUAGE + '/CHANGES_LANGUAGE'
